<template>
  <!--<form class="form-custom" novalidate="novalidate" @submit.prevent="submitHandler">-->
  <!--<div class="section-title">-->
  <!--<h1>实名信息<span class="square">REAL NAME</span></h1>-->
  <!--</div>-->
  <!--<div class="form-group has-feedback" :class="{'has-success': (checkName != null) && checkName,'has-error': (checkName != null) && !checkName}">-->
  <!--<label class="control-label">姓名</label>-->
  <!--<div>-->
  <!--<input class="form-control" type="text" v-model="name" ref="name" placeholder="请输入真实姓名" @blur="validateName">-->
  <!--</div>-->
  <!--<span class="glyphicon form-control-feedback" v-show="checkName != null" :class="{'glyphicon-ok': checkName,'glyphicon-remove': !checkName}"></span>-->
  <!--<span class="help-block">{{nameMsg}}</span>-->
  <!--&lt;!&ndash; <span class="help-block">success message</span> &ndash;&gt;-->
  <!--&lt;!&ndash; <span id="inputSuccess1Status" class="sr-only">(success)</span> &ndash;&gt;-->
  <!--</div>-->
  <!--<div class="form-group has-feedback" :class="{'has-success': (checkIdcard != null) && checkIdcard,'has-error': (checkIdcard != null) && !checkIdcard}">-->
  <!--<label class="control-label">身份证号</label>-->
  <!--<div>-->
  <!--<input class="form-control" type="text" v-model="idcard" ref="idcard" placeholder="请输入身份证号" @blur="validateIdcard">-->
  <!--</div>-->
  <!--<span class="glyphicon form-control-feedback" v-show="checkIdcard != null" :class="{'glyphicon-ok': checkIdcard,'glyphicon-remove': !checkIdcard}"></span>-->
  <!--<span class="help-block">{{idcardMsg}}</span>-->
  <!--&lt;!&ndash; <span class="help-block">success message</span> &ndash;&gt;-->
  <!--&lt;!&ndash; <span id="inputSuccess1Status" class="sr-only">(success)</span> &ndash;&gt;-->
  <!--</div>-->
  <!--<div class="form-group btn-wrap">-->
  <!--<p class="err-wrap text-left"><span>{{errmsg}}</span>&nbsp;</p>-->
  <!--<button class="btn" type="submit">确定<span class="iconfont">&#xe65a;</span></button>-->
  <!--</div>-->
  <!--</form>-->
  <div class="form-custom" style="margin: auto;text-align: center; padding-bottom: 40px">
    <div class="img-wrap">
      <div class="page-caption">
        <h3 class="caption">温馨提示</h3>
        <div class="point"></div>
        <p class="bottom">请使用APP来完成实名认证操作，如未安装APP请前往下载页面安装。</p>
      </div>
      <span>
          <img src="/static/img/app-qrcode.png" alt="" width="160">
        </span>
      <h3 class="caption">（扫码下载APP）</h3>
    </div>
  </div>
</template>

<script>
  import FilterPicker from '@/components/picker/filter'

  export default {
    name: 'ProfileZS',
    components: {FilterPicker},
    data () {
      return {
        errmsg: '',
        req: {},
        name: '',
        checkName: null,
        nameMsg: '',
        idcard: '',
        checkIdcard: null,
        idcardMsg: ''
      }
    },
    methods: {
      validateName () {
        this.checkName = this.validate('name')
        this.checkName && (this.nameMsg = '')
        !this.checkName && (this.errmsg = '')
      },
      validateIdcard () {
        this.checkIdcard = this.validate('idcard')
        this.checkIdcard && (this.idcardMsg = '')
        !this.checkIdcard && (this.errmsg = '')
      },
      validate (choice) {
        let rules = {
          name: '请输入真实姓名',
          idcard: {
            patterns: [{
              pattern: /^[1-9](([0-9]{14})|([0-9]{16}[0-9xX]))$/,
              msg: '请输入正确的身份证号'
            }],
            required: '请输入身份证号'
          }
        }
        if (choice) {
          let obj = {}
          obj[choice] = rules[choice]
          rules = obj
        }
        // let msgField = choice ? choice + 'Msg' : 'errmsg'
        return this.$validate({rules})
      },
      submitHandler () {
        if (this.validate()) {
          let vm = this
          let token = this.$store.state.token
          this.$http({
            url: '/center/realNameAuthentication.jhtml',
            data: {
              uid: token.uid,
              name: vm.name,
              idcard: vm.idcard
            },
            done (d, p, r) {
              vm.$dialog(r.msg, () => {
                vm.$router.push('/u/order')
              })
            },
            fail (m) {
              vm.errmsg = m
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .form-custom
    width 696px
  // height 996px
    padding 46px 40px 60px 60px
    /*margin 42px auto 0*/
    .img-wrap
      text-align center
  /*.form-group*/
  /*width 575px*/
  /*margin-bottom 22px*/
  /*.form-control*/
  /*width 525px*/
</style>



// WEBPACK FOOTER //
// authentication.vue?c1c2ce48